var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"menu"},[_c('Menu',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('div',{staticClass:"content",class:{active:_vm.isCollapse}},[_c('Content',{attrs:{"isCollapse":_vm.isCollapse},on:{"changeManu":_vm.changeManu}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }